/** API route map: URLS.Controller.EEOClassCode */
export const EEOClassCode = {
      Name: 'EEOClassCode/',
      GetAllClassCode: 'get-all',
      AddEEOClassCode: 'add-eeo-class-code',
      UpdateEEOClassCode: 'update-eeo-class-code',
      DeleteEEOClassCode: 'delete-eeo-class-code',
      IsEEOClassCodeAssociated: 'is-associated',
};
